import '../style/loader.scss';

import {FunctionalComponent, h} from "preact";

export const Loader: FunctionalComponent = () => {

    return <div className="spinner circles">
                    <div />
                    <div />
                    <div />
                    <div />
                    <div />
                    <div />
                </div>;
};
